import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';
import { useSelector } from 'react-redux';

const ProfileEditDone = ({
    onSave,
    isSaving,
    setFocuTo = "smiley-selector"
}) => {

    const { theme } = useSelector((state) => state.application);
    const { ref: saveRef, focused: saveFocused, setFocus } = useFocusable({
        focusKey: "save-profile",
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            if (direction == 'up' || direction == 'right') { return false; }
            setFocus(setFocuTo);
            return true;
        },
        onEnterRelease: () => { onSave() },
    });
    return (
        <FocusContext.Provider value={"save-profile"} >
            <span ref={saveRef} style={{ fontSize: "18px", fontWeight: "bold", color: saveFocused ? "#007FFF" : theme?.general?.color ?? "#828282", position: "absolute", right: "20px", top: "20px", cursor: "pointer" }} onClick={onSave}>{isSaving ? <i style={{ color: "#007FFF", marginRight: "5px" }} className={"fa fa-spinner fa-spin fa-lg"} /> : "Done"}</span>
        </FocusContext.Provider >
    );
}

export default ProfileEditDone;
